import React from "react";

type Props = {};

const Industries = (props: Props) => {
  return <div>Industries</div>;
};

export default Industries;
